import React, { useContext } from "react";
import {
	stringsKey as sharedStringsKey,
	englishStrings as sharedEnglishStrings,
} from "../common/Shared.Strings";
import {
	stringsKey as languagePickerStringsKey,
	englishStrings as languagePickerEnglishStrings,
} from "../components/LanguagePicker/LanguagePicker.Strings";
import {
	stringsKey as navigationDrawerStringsKey,
	englishStrings as navigationDrawerEnglishStrings,
} from "../components/NavigationDrawer/NavigationDrawer.Strings";
import {
	stringsKey as homePageStringsKey,
	englishStrings as homePageEnglishStrings,
} from "../components/HomePage/HomePage.Strings";
import {
	stringsKey as countryListStringsKey,
	englishStrings as countryListEnglishStrings,
} from "../components/Country/List/CountryList.Strings";
import {
	stringsKey as countryDialogStringsKey,
	englishStrings as countryDialogEnglishStrings,
} from "../components/Country/Dialog/CountryDialog.Strings";
import {
	stringsKey as variablesListStringsKey,
	englishStrings as variablesListEnglishStrings,
} from "../components/Variables/List/VariablesList.Strings";
import {
	stringsKey as variablesListDataGridStringsKey,
	englishStrings as variablesListDataGridEnglishStrings,
} from "../components/Variables/ListDataGrid/VariablesListDataGrid.Strings";
import {
	stringsKey as errorPageStringsKey,
	englishStrings as errorPageEnglishStrings,
} from "../components/ErrorPage/ErrorPage.Strings";
import {
	stringsKey as messageTypeSelectionStringsKey,
	englishStrings as messageTypeSelectionStrings,
} from "../components/BatchNotification/MessageTypeSelection/MessageTypeSelection.Strings";
import {
	stringsKey as batchNotificationWizardStringsKey,
	englishStrings as batchNotificationWizardStrings,
} from "../components/BatchNotification/BatchNotificationWizard/BatchNotificationWizard.Strings";
import {
	stringsKey as templatesAwaitingApprovalStringsKey,
	englishStrings as templatesAwaitingApprovalEnglishStrings,
} from "../components/TemplatesAwaitingApproval/TemplatesAwaitingApproval.Strings";
import {
	stringsKey as templateListDataGridStringsKey,
	englishStrings as templateListDataGridEnglishStrings,
} from "../components/TemplateListDataGrid/TemplateListDataGrid.Strings";
import {
	stringsKey as templateListDataGridExpandedRowStringsKey,
	englishStrings as templateListDataGridExpandedRowEnglishStrings,
} from "../components/TemplateListDataGrid/TemplateListDataGridExpandedRow/TemplateListDataGridExpandedRow.Strings";
import {
	stringsKey as templateListStringsKey,
	englishStrings as templateListEnglishStrings,
} from "../components/TemplateList/TemplateList.Strings";
import {
	stringsKey as scheduledTemplateListStringsKey,
	englishStrings as scheduledTemplateListEnglishStrings,
} from "../components/ScheduledTemplateList/ScheduledTemplateList.Strings";
import {
	stringsKey as addVariableButtonStringsKey,
	englishStrings as addVariableButtonEnglishStrings,
} from "../components/Variables/AddButton/AddButton.Strings";
import {
	stringsKey as languageSelectionStringsKey,
	englishStrings as languageSelectionEnglishStrings,
} from "../components/BatchNotification/LanguageSelection/LanguageSelection.Strings";
import {
	stringsKey as messageLanguageConfigurationStringsKey,
	englishStrings as messageLanguageConfigurationEnglishStrings,
} from "../components/BatchNotification/MessageLanguageConfiguration/MessageLanguageConfiguration.Strings";
import {
	stringsKey as messageLanguageRowStringsKey,
	englishStrings as messageLanguageRowEnglishStrings,
} from "../components/BatchNotification/MessageLanguageRow/MessageLanguageRow.Strings";
import {
	stringsKey as messageTitleStringsKey,
	englishStrings as messageTitleEnglishStrings,
} from "../components/BatchNotification/MessageTitle/MessageTitle.Strings";
import {
	stringsKey as recurringSchedulerDialogStringsKey,
	englishStrings as recurringSchedulerDialogEnglishStrings,
} from "../components/BatchNotification/RecurringSchedulerDialog/RecurringSchedulerDialog.Strings";
import {
	stringsKey as messageSegmentPreviewStringsKey,
	englishStrings as messageSegmentPreviewEnglishStrings,
} from "../components/BatchNotification/MessageSegmentPreview/MessageSegmentPreview.Strings";
import {
	stringsKey as fileUploadStringsKey,
	englishStrings as fileUploadEnglishStrings,
} from "../components/BatchNotification/FileUpload/FileUpload.Strings";
import {
	stringsKey as groupNameStringsKey,
	englishStrings as groupNameEnglishStrings,
} from "../components/BatchNotification/GroupName/GroupName.Strings";
import {
	stringsKey as excelFileUploadStringsKey,
	englishStrings as excelFileUploadEnglishStrings,
} from "../components/BatchNotification/ExcelFileUpload/ExcelFileUpload.Strings";
import {
	stringsKey as groupDetailTablePreviewStringsKey,
	englishStrings as groupDetailTablePreviewEnglishStrings,
} from "../components/BatchNotification/GroupDetailTablePreview/GroupDetailTablePreview.Strings";
import {
	stringsKey as groupConfigurationStringsKey,
	englishStrings as groupConfigurationEnglishStrings,
} from "../components/BatchNotification/GroupConfiguration/GroupConfiguration.Strings";
import {
	stringsKey as messageSenderConfigurationStringsKey,
	englishStrings as messageSenderConfigurationEnglishStrings,
} from "../components/BatchNotification/MessageSenderConfiguration/MessageSenderConfiguration.Strings";
import {
	stringsKey as messageScheduleConfigurationStringsKey,
	englishStrings as messageScheduleConfigurationEnglishStrings,
} from "../components/BatchNotification/MessageScheduleConfiguration/MessageScheduleConfiguration.Strings";
import {
	stringsKey as dateTimePickerStringsKey,
	englishStrings as dateTimePickerEnglishStrings,
} from "../components/DateTimePicker/DateTimePicker.Strings";
import {
	stringsKey as timeZoneSelectionStringsKey,
	englishStrings as timeZoneSelectionEnglishStrings,
} from "../components/BatchNotification/TimeZoneSelection/TimeZoneSelection.Strings";
import {
	stringsKey as actionColumnStringsKey,
	englishStrings as actionColumnEnglishStrings,
} from "../components/Variables/ActionColumn/ActionColumn.Strings";
import {
	stringsKey as messageScheduleRowStringsKey,
	englishStrings as messageScheduleRowEnglishStrings,
} from "../components/BatchNotification/MessageScheduleRow/MessageScheduleRow.Strings";
import {
	stringsKey as batchMessageDetailPreviewStringsKey,
	englishStrings as batchMessageDetailPreviewEnglishStrings,
} from "../components/BatchNotification/BatchMessageDetailPreview/BatchMessageDetailPreview.Strings";
import {
	stringsKey as ivrFlowConfigurationStringsKey,
	englishStrings as ivrFlowConfigurationEnglishStrings,
} from "../components/RequestForHelpTemplates/IVRFlowConfiguration/IVRFlowConfiguration.strings";
import {
	stringsKey as ivrFlowTypeConfigurationStringsKey,
	englishStrings as ivrFlowTypeConfigurationEnglishStrings,
} from "../components/RequestForHelpTemplates/IVRFlowTypeConfiguration/IVRFlowTypeConfiguration.Strings";
import {
	stringsKey as askQuestionWidgetStringsKey,
	englishStrings as askQuestionWidgetEnglishStrings,
} from "../components/RequestForHelpTemplates/AskQuestionWidget/AskQuestionWidget.Strings";
import {
	stringsKey as responseMapWidgetStringsKey,
	englishStrings as responseMapWidgetEnglishStrings,
} from "../components/RequestForHelpTemplates/ResponseMapWidget/ResponseMapWidget.Strings";
import {
	stringsKey as failureActionConfigurationStringsKey,
	englishStrings as failureActionConfigurationEnglishStrings,
} from "../components/RequestForHelpTemplates/FailureActionConfiguration/FailureActionConfiguration.Strings";
import {
	stringsKey as nextActionSelectionStringsKey,
	englishStrings as nextActionSelectionEnglishStrings,
} from "../components/RequestForHelpTemplates/NextActionSelection/NextActionSelection.Strings";
import {
	stringsKey as ivrFlowWizardConfigurationStringsKey,
	englishStrings as ivrFlowWizardConfigurationEnglishStrings,
} from "../components/RequestForHelpTemplates/IVRFlowWizardConfiguration/IVRFlowWizardConfiguration.Strings";
import {
	stringsKey as ivrFlowWizardStepperStringsKey,
	englishStrings as ivrFlowWizardStepperEnglishStrings,
} from "../components/RequestForHelpTemplates/IVRFlowWizardStepper/IVRFlowWizardStepper.Strings";
import {
	stringsKey as ivrStudioFlowStringsKey,
	englishStrings as ivrStudioFlowEnglishStrings,
} from "../components/RequestForHelpTemplates/IVRStudioFlow/IVRStudioFlow.Strings";
import {
	stringsKey as logRequestForHelpWidgetStringsKey,
	englishStrings as logRequestForHelpWidgetEnglishStrings,
} from "../components/RequestForHelpTemplates/LogRequestForHelpWidget/LogRequestForHelp.Strings";
import {
	stringsKey as pickLanguageWidgetStringsKey,
	englishStrings as pickLanguageWidgetEnglishStrings,
} from "../components/RequestForHelpTemplates/PickLanguageWidget/PickLanguageWidget.Strings";
import {
	stringsKey as sendMessageWidgetStringsKey,
	englishStrings as sendMessageWidgetEnglishStrings,
} from "../components/RequestForHelpTemplates/SendMessageWidget/SendMessageWidget.Strings";
import {
	stringsKey as multiLanguageWidgetStringsKey,
	englishStrings as multiLanguageWidgetEnglishStrings,
} from "../components/RequestForHelpTemplates/MultiLanguageWidget/MultiLanguageWidget.Strings";
import {
	stringsKey as ussdScriptDialogStringsKey,
	englishStrings as ussdScriptDialogEnglishStrings,
} from "../components/RequestForHelpTemplates/USSDScriptDialog/USSDScriptDialog.Strings";
import {
	stringsKey as templateLibraryViewPageStringsKey,
	englishStrings as templateLibraryViewPageEnglishStrings,
} from "../components/TemplateLibraryViewPage/TemplateLibraryViewPage.Strings";
import {
	stringsKey as userPermissionsStringsKey,
	englishStrings as userPermissionsEnglishStrings,
} from "../components/UserPermissions/UserPermissions.Strings";

const generateValues = <T extends { [key: string]: any }>(
	componentsObject: any,
	componentKey: string,
	defaultValues: T
): T => {
	const coKeys = Object.keys(componentsObject);
	const coKey = coKeys.find((e) => e === componentKey);
	const componentStringsFromObject =
		coKey === undefined ? {} : componentsObject[coKey];

	const res = { ...defaultValues };
	const keys = Object.keys(res);
	keys.forEach((key) => {
		(res[key] as any) = componentStringsFromObject[key] || res[key];
	});
	return res;
};

// This function needs to return an object where the keys are the component/section identifiers (string)
// and the values are a [key: string]: string of strings that need to be displayed in the application.
// Using imports to import the keyName and default (english) string values to use,
// as make sense to keeps these close to the components that need them.
// The sample below, also extends this with a "Shared" section, for common string used application wide.
export const generateComponentStringsContext = (data: { components: any }) => {
	const componentsObject =
		typeof data.components === "object" ? data.components : {};
	return {
		[sharedStringsKey]: generateValues(
			componentsObject,
			sharedStringsKey,
			sharedEnglishStrings
		),
		[languagePickerStringsKey]: generateValues(
			componentsObject,
			languagePickerStringsKey,
			languagePickerEnglishStrings
		),
		[navigationDrawerStringsKey]: generateValues(
			componentsObject,
			navigationDrawerStringsKey,
			navigationDrawerEnglishStrings
		),
		[homePageStringsKey]: generateValues(
			componentsObject,
			homePageStringsKey,
			homePageEnglishStrings
		),
		[countryListStringsKey]: generateValues(
			componentsObject,
			countryListStringsKey,
			countryListEnglishStrings
		),
		[countryDialogStringsKey]: generateValues(
			componentsObject,
			countryDialogStringsKey,
			countryDialogEnglishStrings
		),
		[variablesListStringsKey]: generateValues(
			componentsObject,
			variablesListStringsKey,
			variablesListEnglishStrings
		),
		[variablesListDataGridStringsKey]: generateValues(
			componentsObject,
			variablesListDataGridStringsKey,
			variablesListDataGridEnglishStrings
		),
		[actionColumnStringsKey]: generateValues(
			componentsObject,
			actionColumnStringsKey,
			actionColumnEnglishStrings
		),
		[addVariableButtonStringsKey]: generateValues(
			componentsObject,
			addVariableButtonStringsKey,
			addVariableButtonEnglishStrings
		),
		[errorPageStringsKey]: generateValues(
			componentsObject,
			errorPageStringsKey,
			errorPageEnglishStrings
		),
		[batchNotificationWizardStringsKey]: generateValues(
			componentsObject,
			batchNotificationWizardStringsKey,
			batchNotificationWizardStrings
		),
		[messageTypeSelectionStringsKey]: generateValues(
			componentsObject,
			messageTypeSelectionStringsKey,
			messageTypeSelectionStrings
		),
		[templatesAwaitingApprovalStringsKey]: generateValues(
			componentsObject,
			templatesAwaitingApprovalStringsKey,
			templatesAwaitingApprovalEnglishStrings
		),
		[templateListDataGridStringsKey]: generateValues(
			componentsObject,
			templateListDataGridStringsKey,
			templateListDataGridEnglishStrings
		),
		[templateListDataGridExpandedRowStringsKey]: generateValues(
			componentsObject,
			templateListDataGridExpandedRowStringsKey,
			templateListDataGridExpandedRowEnglishStrings
		),
		[templateListStringsKey]: generateValues(
			componentsObject,
			templateListStringsKey,
			templateListEnglishStrings
		),
		[scheduledTemplateListStringsKey]: generateValues(
			componentsObject,
			scheduledTemplateListStringsKey,
			scheduledTemplateListEnglishStrings
		),
		[languageSelectionStringsKey]: generateValues(
			componentsObject,
			languageSelectionStringsKey,
			languageSelectionEnglishStrings
		),
		[messageLanguageConfigurationStringsKey]: generateValues(
			componentsObject,
			messageLanguageConfigurationStringsKey,
			messageLanguageConfigurationEnglishStrings
		),
		[messageLanguageRowStringsKey]: generateValues(
			componentsObject,
			messageLanguageRowStringsKey,
			messageLanguageRowEnglishStrings
		),
		[messageTitleStringsKey]: generateValues(
			componentsObject,
			messageTitleStringsKey,
			messageTitleEnglishStrings
		),
		[recurringSchedulerDialogStringsKey]: generateValues(
			componentsObject,
			recurringSchedulerDialogStringsKey,
			recurringSchedulerDialogEnglishStrings
		),
		[messageSegmentPreviewStringsKey]: generateValues(
			componentsObject,
			messageSegmentPreviewStringsKey,
			messageSegmentPreviewEnglishStrings
		),
		[fileUploadStringsKey]: generateValues(
			componentsObject,
			fileUploadStringsKey,
			fileUploadEnglishStrings
		),
		[groupNameStringsKey]: generateValues(
			componentsObject,
			groupNameStringsKey,
			groupNameEnglishStrings
		),
		[excelFileUploadStringsKey]: generateValues(
			componentsObject,
			excelFileUploadStringsKey,
			excelFileUploadEnglishStrings
		),
		[groupDetailTablePreviewStringsKey]: generateValues(
			componentsObject,
			groupDetailTablePreviewStringsKey,
			groupDetailTablePreviewEnglishStrings
		),
		[groupConfigurationStringsKey]: generateValues(
			componentsObject,
			groupConfigurationStringsKey,
			groupConfigurationEnglishStrings
		),
		[messageSenderConfigurationStringsKey]: generateValues(
			componentsObject,
			messageSenderConfigurationStringsKey,
			messageSenderConfigurationEnglishStrings
		),
		[messageScheduleConfigurationStringsKey]: generateValues(
			componentsObject,
			messageScheduleConfigurationStringsKey,
			messageScheduleConfigurationEnglishStrings
		),
		[dateTimePickerStringsKey]: generateValues(
			componentsObject,
			dateTimePickerStringsKey,
			dateTimePickerEnglishStrings
		),
		[timeZoneSelectionStringsKey]: generateValues(
			componentsObject,
			timeZoneSelectionStringsKey,
			timeZoneSelectionEnglishStrings
		),
		[messageScheduleRowStringsKey]: generateValues(
			componentsObject,
			messageScheduleRowStringsKey,
			messageScheduleRowEnglishStrings
		),
		[batchMessageDetailPreviewStringsKey]: generateValues(
			componentsObject,
			batchMessageDetailPreviewStringsKey,
			batchMessageDetailPreviewEnglishStrings
		),
		[ivrFlowConfigurationStringsKey]: generateValues(
			componentsObject,
			ivrFlowConfigurationStringsKey,
			ivrFlowConfigurationEnglishStrings
		),
		[ivrFlowTypeConfigurationStringsKey]: generateValues(
			componentsObject,
			ivrFlowTypeConfigurationStringsKey,
			ivrFlowTypeConfigurationEnglishStrings
		),
		[askQuestionWidgetStringsKey]: generateValues(
			componentsObject,
			askQuestionWidgetStringsKey,
			askQuestionWidgetEnglishStrings
		),
		[responseMapWidgetStringsKey]: generateValues(
			componentsObject,
			responseMapWidgetStringsKey,
			responseMapWidgetEnglishStrings
		),
		[failureActionConfigurationStringsKey]: generateValues(
			componentsObject,
			failureActionConfigurationStringsKey,
			failureActionConfigurationEnglishStrings
		),
		[nextActionSelectionStringsKey]: generateValues(
			componentsObject,
			nextActionSelectionStringsKey,
			nextActionSelectionEnglishStrings
		),
		[ivrFlowWizardConfigurationStringsKey]: generateValues(
			componentsObject,
			ivrFlowWizardConfigurationStringsKey,
			ivrFlowWizardConfigurationEnglishStrings
		),
		[ivrFlowWizardStepperStringsKey]: generateValues(
			componentsObject,
			ivrFlowWizardStepperStringsKey,
			ivrFlowWizardStepperEnglishStrings
		),
		[ivrStudioFlowStringsKey]: generateValues(
			componentsObject,
			ivrStudioFlowStringsKey,
			ivrStudioFlowEnglishStrings
		),
		[logRequestForHelpWidgetStringsKey]: generateValues(
			componentsObject,
			logRequestForHelpWidgetStringsKey,
			logRequestForHelpWidgetEnglishStrings
		),
		[pickLanguageWidgetStringsKey]: generateValues(
			componentsObject,
			pickLanguageWidgetStringsKey,
			pickLanguageWidgetEnglishStrings
		),
		[sendMessageWidgetStringsKey]: generateValues(
			componentsObject,
			sendMessageWidgetStringsKey,
			sendMessageWidgetEnglishStrings
		),
		[multiLanguageWidgetStringsKey]: generateValues(
			componentsObject,
			multiLanguageWidgetStringsKey,
			multiLanguageWidgetEnglishStrings
		),
		[ussdScriptDialogStringsKey]: generateValues(
			componentsObject,
			ussdScriptDialogStringsKey,
			ussdScriptDialogEnglishStrings
		),
		[templateLibraryViewPageStringsKey]: generateValues(
			componentsObject,
			templateLibraryViewPageStringsKey,
			templateLibraryViewPageEnglishStrings
		),
		[userPermissionsStringsKey]: generateValues(
			componentsObject,
			userPermissionsStringsKey,
			userPermissionsEnglishStrings
		),
	};
};
type ComponentStringsContextType = ReturnType<
	typeof generateComponentStringsContext
>;

export const ComponentStringsContext = React.createContext<ComponentStringsContextType>(
	generateComponentStringsContext({ components: {} })
);
export const useGetComponentStringsContext = (): ComponentStringsContextType => {
	return useContext(ComponentStringsContext);
};
